import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  DelGoodDetailMutation,
  DelGoodDetailMutationVariables,
} from "../generated/graphql";

const DEL_GOOD_DETAIL_MUTATION = gql`
  mutation delGoodDetail($input: DelGoodDetailInput!) {
    delGoodDetail(input: $input) {
      ok
      err
    }
  }
`;

export const useDelGoodDetail = (
  onCompleted?: (data: DelGoodDetailMutation) => void,
  onError?: (Error: ApolloError) => void
) => {
  return useMutation<DelGoodDetailMutation, DelGoodDetailMutationVariables>(
    DEL_GOOD_DETAIL_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
